<section class="impressum" aria-labelledby="impressum-heading">
  <div class="container impressum__inner">
    <h1 id="impressum-heading" class="impressum__page-title">Impresszum</h1>

    @if (owner(); as ownerSection) {
      <article class="impressum__block">
        <h2 class="impressum__section-heading">{{ ownerSection.title }}</h2>
        <dl class="impressum__list">
          @for (row of ownerSection.rows; track row.label) {
            <div class="impressum__pair">
              <dt>{{ row.label }}:</dt>
              <dd>
                @if (row.href) {
                  <a
                    [href]="row.href"
                    [attr.target]="isExternalHttpHref(row.href) ? '_blank' : null"
                    [attr.rel]="isExternalHttpHref(row.href) ? 'noopener noreferrer' : null"
                  >
                    {{ row.value }}
                  </a>
                } @else {
                  {{ row.value }}
                }
              </dd>
            </div>
          }
        </dl>
      </article>
    }

    <article class="impressum__block">
      <h2 class="impressum__section-heading">{{ hosting.title }}</h2>
      <dl class="impressum__list">
        @for (row of hosting.rows; track row.label) {
          <div class="impressum__pair">
            <dt>{{ row.label }}:</dt>
            <dd>
              @if (row.href) {
                <a
                  [href]="row.href"
                  [attr.target]="isExternalHttpHref(row.href) ? '_blank' : null"
                  [attr.rel]="isExternalHttpHref(row.href) ? 'noopener noreferrer' : null"
                >
                  {{ row.value }}
                </a>
              } @else {
                {{ row.value }}
              }
            </dd>
          </div>
        }
      </dl>
    </article>
  </div>
</section>
